import type { ReactNode } from 'react'
import Mention from '@tiptap/extension-mention'
import { NodeViewWrapper, ReactNodeViewRenderer, type NodeViewProps } from '@tiptap/react'
import { Mention as MentionChip } from 'modules/community/components/editor/elements/mention/mention'

const MentionNodeView = ({ node }: NodeViewProps): ReactNode => (
  <NodeViewWrapper className="inline">
    <MentionChip
      element={{
        type: 'mention',
        id: Number(node.attrs.id) || 0,
        displayName: String(node.attrs.label ?? ''),
        profileImageUrl: String(node.attrs.profileImageUrl ?? ''),
        children: [{ text: '' }],
      }}
    />
  </NodeViewWrapper>
)

export const PostMention = Mention.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      profileImageUrl: {
        default: '',
        parseHTML: element => element.dataset.avatarUrl ?? '',
        renderHTML: attributes =>
          attributes.profileImageUrl ? { 'data-avatar-url': attributes.profileImageUrl } : {},
      },
    }
  },

  addNodeView() {
    return ReactNodeViewRenderer(MentionNodeView, { as: 'span' })
  },
})
